import { render } from "./private-training.vue?vue&type=template&id=39a97118&scoped=true"
import script from "./private-training.vue?vue&type=script&lang=js"
export * from "./private-training.vue?vue&type=script&lang=js"

import "./private-training.vue?vue&type=style&index=0&id=39a97118&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a97118"]])

export default __exports__